import HtmlEditBlock, { HtmlEditBlockProps } from './HtmlEditBlock';
import withInteractor from './HtmlEditBlock.interactor';
import withPresenter from './HtmlEditBlock.presenter';

export type { HtmlEditBlockProps };
export default withInteractor(withPresenter(HtmlEditBlock));
